import type { AuditedVideoExpanded } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWRImmutable from "swr/immutable";

const useAuditedVideos = () => {
	const { isSignedIn } = useAuth();

	const {
		data: auditedVideos,
		mutate,
		...rest
	} = useSWRImmutable<AuditedVideoExpanded[]>(isSignedIn && `/videos/audited`, {
		errorRetryCount: 0,
	});

	return { auditedVideos, ...rest };
};

export default useAuditedVideos;
